<template>
    <Card>
        <div class="card-body d-flex justify-content-between">
            <router-link
                class="btn btn-link legitRipple"
                :to="{
                    name: 'ClientCreatePage',
                    params: {
                        projectUuid: $route.params.projectUuid
                    }
                }">
                <i class="icon-plus3 mr-2"></i>
                {{ translate('buttons.create') }}
            </router-link>
            <button type="button" class="btn btn-light" @click="$refs.exportClientsModal.show()">
                <i class="icon-database-export mr-2"></i>
                {{ $t('buttons.export') }}
            </button>
        </div>
        <FetchTable :handle="tableHandle" :url="table.url" :columns="table.columns" v-model:orders="table.orders">
            <template #td-id="{row}">
                <router-link
                    :to="{
                        name: 'ClientEditPage',
                        params: {
                            clientUuid: row.uuid
                        }
                    }"
                >
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-created_at="{row}">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
            <template #td-phone="{row}">
                <AppNullableCell>
                    <template #default v-if="row.phone">
                        {{ row.phone }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-email="{row}">
                <AppNullableCell>
                    <template #default v-if="row.email">
                        {{ row.email }}
                    </template>
                </AppNullableCell>
            </template>
        </FetchTable>
    </Card>
    <ExportClientsModal ref="exportClientsModal" />
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";
import DateFormatter from "../../../../services/DateFormatter";
import ExportClientsModal from "./modals/ExportClientsModal.vue";
import AppNullableCell from "../../../components/tables/AppNullableCell.vue";
export default {
    name: "ClientsIndexPage",
    components: {
        Card, FetchTable, ExportClientsModal, AppNullableCell
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: `/projects/${this.$route.params.projectUuid}/crm/clients`,
                orders: [{
                    column: 'id',
                    dir: 'desc'
                }],
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '100px', type: 'string', order: true},
                    {key: 'name', name: this.$t('table.titles.name'), width: '80px', type: 'string', order: true},
                    {key: 'phone', name: this.$t('table.titles.phone'), width: '300px', type: 'string', order: false},
                    {key: 'email', name: this.$t('table.titles.email'), width: '150px', type: 'string', order: false},
                    {key: "created_at", name: this.$t('table.titles.created_at'), width: '150px', type: 'string', order: true},
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows()
    }
}
</script>
